import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useInvoice} from '../hooks/useInvoice';
import {useInvoicesSelection} from '../hooks/useInvoicesSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';

import {IndexPage as InvoiceItemsPage} from '../../invoice-items/pages/IndexPage.tsx'

export const EditPage = () => {

    const {invoiceId} = useParams();

    if (typeof invoiceId === 'undefined') {
        throw new Error('invoiceId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = useInvoice(invoiceId);

    const {handleClearSelection} = useInvoicesSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);


    if (loading || !component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile
                            record={component}
                        />
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <InvoiceItemsPage/>
                    </Grid.Col>
                </Grid>
                :
                <RecordForm
                    record={component}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};